export const SIGN_IN_STEP = {
    LOGIN: 'login',
    VERIFY_PASSWORD: 'verifyPassword',
    VERIFY_EMAIL: 'verifyEmail',
    FILL_PROFILE: 'fillProfile',
};
